import React, {
  ForwardedRef, forwardRef,
} from 'react';
import '../../ScreenReportPdf/style.scss';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/rootState';
import ComponentMorningReportToPrint from './componentToPrint';

const getPageMargins = `
 @media print {
    @page {
      margin: 10px;
      size: A4;
    }  
    .page-break {
      display: block;
      page-break-before: always;
    }
}
`;

function ReportPdf({ printRef }: { printRef: ForwardedRef<HTMLInputElement> }) {
  const pageMarginsCSS = getPageMargins;

  const { morningReportData } = useSelector((state:RootState) => state.dashboardReducer);

  if (!morningReportData) {
    return null;
  }

  return (
    <>
      <style>{pageMarginsCSS}</style>
      <div style={{
        display: 'none', width: '900px', margin: '0 auto', backgroundColor: '#FFFFFF',
      }}
      >
        <ComponentMorningReportToPrint ref={printRef} />
      </div>
    </>
  );
}

const MorningReportPdf = forwardRef(ReportPdf);

export default MorningReportPdf;
